import React, { useEffect, useState } from 'react'
import { buildAPIGetLoggerSummaryModel, APIGetLoggerSummaryModel } from "models/APIGetLoggerSummaryModel";
import { Redirect } from 'react-router-dom'
import Loader from '../../Utils/Loader/NewLoader2025'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment, { Duration } from 'moment';
import UploadDialog from "../../components/ImageUpload/UploadDialog" 
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import GoogleMapsMobileDash from '../../components/Map/GoogleMapsMobileDash'
import type { google } from 'google.maps'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import Tor1N from '../../assets/1N.png'
import TextLog from '../../assets/Textlog.png'
import Tor4S from '../../assets/TOR-4S.png'
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import Comments from '../../components/Comments/Comments';
import MobileImagePanel from '../../components/ImageUpload/MobileImagePanel';
import EventsPanelMobile from '../../components/Events/EventsPanelMobile';
import DeviceSummaryMobile from '../../components/DeviceSummary/DeviceSummaryMobile'




interface Props {
    classes: {
        cardTitleWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: string;
        };
        search: string;
    };

}

interface RedirectProps {
    serial: number | null
}

interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    id: number
    deviceName: string
}



const DeviceDetailMobile: React.FC<Props> = ({ classes, history, location }) => {

    //hooks
    const intl: IntlShape = useIntl()
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    //state
    const [redirect, setRedirect] = useState<boolean>()
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>()
    const [loading, setLoading] = useState<boolean>(true)
    const [serial, setSerial] = useState<string>("")
    const [allowBack, setAllowBack] = useState<boolean>(true)
    const [loggerType, setLoggerType] = useState<string>("")
    const [modelId, setModelId] = useState<string>("")
    const [isDormant, setIsDormant] = useState<boolean>(false)
    const [loggerIds, setLoggerIds] = useState<number>()
    const [startDate, setStartDate] = useState<Date>()
    const [channels, setChannels] = useState<Array<string>>([])
    const [channelAUnits, setChannelAUnits] = useState<string>()
    const [channelBUnits, setChannelBUnits] = useState<string>()
    const [channelCUnits, setChannelCUnits] = useState<string>()
    const [channelDUnits, setChannelDUnits] = useState<string>()
    const [channelEUnits, setChannelEUnits] = useState<string>()
    const [channelCDp, setChannelCDp] = useState<number | null>()
    const [channelDDp, setChannelDDp] = useState<number | null>()
    const [channelEDp, setChannelEDp] = useState<number | null>()
    const [meterConfig, setMeterConfig] = useState<number | null>()
    const [siteName, setSiteName] = useState<string>("")
    const [uploadDialogOpen, setUploadDialogOpen] = useState<boolean>()
    const [mapModal, setMapModal] = useState<boolean>()
    const [googleMapInstance, setGoogleMapInstance] = useState<google.maps.Map | null>()
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [imageSrc, setImageSrc] = useState<string>()
    const [model, setModel] = useState<string>()
    const [disableBackBtn, setDisableBackBtn] = useState<boolean>(false)
    const [disableMapBtn, setDisableMapBtn] = useState<boolean>(false)
    const [deviceData, setDeviceData] = useState<APIGetLoggerSummaryModel | undefined>()


    useEffect(() => {
        reloadData()
    }, [])

    const reloadData = ():void => {
        let serialTemp = "";
        let allowBack = true;
        if (location.state) {
            serialTemp = location.state.serial;
        }
        else {
            serialTemp = (location.search.split('='))[1];
            allowBack = false;
            setDisableBackBtn(true)
        }
        setSerial(serialTemp)
        setAllowBack(allowBack)

        CallGetAPI(CreateUrl('/api/aquaguard/LoggerBySerial?serial=' + serialTemp), {})
            .then(response => {
                const data = buildAPIGetLoggerSummaryModel(response);
                setDeviceData(data)
                console.log(data)
                sessionStorage.setItem('selectedLoggers', data.Id.toString())
                const channelsTemp = data.Channels.length > 4 ? data.Channels.split(",") : ["A", "B", "C", "D", "E"];
                const meterConfig = data.MeterConfig ? data.MeterConfig : 0
                if ((meterConfig & 0x01) == 0) {
                    channelsTemp[0] = "";
                }
                if ((meterConfig & 0x08) == 0) {
                    channelsTemp[1] = "";
                }
                if ((meterConfig & 0x0100) == 0) {
                    channelsTemp[2] = "";
                }
                if ((meterConfig & 0x0800) == 0) {
                    channelsTemp[3] = "";
                }
                if ((meterConfig & 0x2000) == 0) {
                    channelsTemp[4] = "";
                }
                console.log(data.ModelId, data.Model)
                let imageSrcTemp = Tor1N
                switch (data.Model) {
                    case 'Textlog':
                        imageSrcTemp = TextLog
                        break
                    case 'TOR-S':
                        imageSrcTemp = Tor4S
                        break
                }
                if (data.GpsLatitude && data.GpsLongitude) {
                    setMarkers([{
                        position: { lat: data.GpsLatitude, lng: data.GpsLongitude },
                        icon: yellowMarker,
                        serial: parseInt(serialTemp),
                        id: data.Id,
                        deviceName: data.SiteId
                    }])
                } else {
                    setDisableMapBtn(true)
                }
                setImageSrc(imageSrcTemp)
                setLoggerType(data.Model)
                setModelId(data.ModelId)
                setModel(data.Model)
                setIsDormant(data.Dormant)
                setLoggerIds(data.Id)
                setStartDate(moment().subtract(7, "days").startOf('day').toDate())
                setChannels(channelsTemp)
                setChannelAUnits(data.ChannelAUnits != null ? data.ChannelAUnits : "")
                setChannelBUnits(data.ChannelBUnits != null ? data.ChannelBUnits : "")
                setChannelCDp(data.ChannelCDp)
                setChannelCUnits(data.ChannelCUnits != null ? data.ChannelCUnits : "")
                setChannelDDp(data.ChannelDDp)
                setChannelDUnits(data.ChannelDUnits != null ? data.ChannelDUnits : "")
                setChannelEDp(data.ChannelEDp)
                setChannelEUnits(data.ChannelEUnits != null ? data.ChannelEUnits : "")
                setMeterConfig(meterConfig)
                setSiteName(data.SiteNameUserFriendly + "(" + data.SiteName + ")")
                setLoading(false)


            })
            .catch((error: Error) => {
                setLoggerType('unknown')
                console.error("Unauthorized!:{0}", error)
                setLoading(false)
            });
    }


    const onMapLoad = (map: google.maps.Map): void => {
        map.setMapTypeId("hybrid");
        map.setZoom(15);
        setGoogleMapInstance(map)
    };

    const toggleMapModal = (): void => {
        setMapModal(!mapModal)
    }


    const handleGraphClick = (): void => {
        if (loggerIds) {
            sessionStorage.setItem('selectedLoggers', loggerIds?.toString())
            setRedirect(true)
            setRedirectPath('/portal/multiLoggerGraph')
            setRedirectProps(
                {
                    groupId: null,
                    loggers: [loggerIds],
                    loggerId: null,
                    showBackButton: true,
                    serial: null
                }
            )
        }
    }

    const handleBackClick = ():void => {
        if (!disableBackBtn) {
            history.goBack()
        } else {
            window.location.href = '/portal/dashboard'
        }
    }

    const handleMapClick = (): void => {
        toggleMapModal()
    }

    const handleUploadPhoto = (): void => {
        setUploadDialogOpen(!uploadDialogOpen)
    }



    return (
        <>{
            !redirect ?
                <div>
                    <UploadDialog
                        show={uploadDialogOpen}
                        title={intl.formatMessage({ id: "Upload Image" })}
                        siteId={0}
                        loggerId={loggerIds}
                        onSubmit={(): void => {
                            setUploadDialogOpen(false)
                            reloadData()
                        }}
                        onCancel={(): void => setUploadDialogOpen(false)}
                    />
                    <Modal
                        show={mapModal}
                        style={{
                            marginTop: isLandscape ? "20px" : "100px",
                        }}
                    >
                        <Modal.Header>
                            <Modal.Title>
                                <FormattedMessage id='Map' />
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ margin: "0 5px 0 8px" }}>
                                <GoogleMapsMobileDash
                                    onMapLoad={onMapLoad}
                                    markers={markers}
                                    handleMarkerClick={(): void => {/**/ }}
                                    showTooltip={false}
                                    clickedMarker={null}
                                    handleTooltipCloseClick={(): void => {/**/ }}
                                    deviceOverviewClick={(): void => {/**/ }}
                                    center={markers[0]?.position}
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <FullWidthMobileButton disabled={false} color="primary" onClick={(): void => toggleMapModal()} text={intl.formatMessage({ id: "Exit" })} />
                        </Modal.Footer>
                    </Modal>

                
                    {loading &&
                        <div style={{
                        position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                        }}>
                            <Loader color={undefined} />
                        </div>
                    }
                    {!loading &&
                        <>
                        <div style={{ display: "flex", justifyContent: "center", margin: "-20px 0 20px 0" }}>
                            <div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    {(model !== 'Textlog' && model !== 'TOR-S') ?
                                        <img style={{ margin: 0, width: '25%', height: '25%' }} src={imageSrc} />
                                        :
                                        <img style={{ margin: 0, width: '50%', height: '50%' }} src={imageSrc} />
                                    }
                                </div>
                                <h3 style={{ margin: 0, textAlign: 'center' }}><b>{`${intl.formatMessage({ id: 'Serial' })}: ${serial}`}</b></h3>
                            </div>
                        </div> 
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: 30 }}>
                            <div style={{ width: "47%" }}>
                                <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Back" })} color="error" onClick={(): void => handleBackClick()} />
                            </div>
                            <div style={{ width: "47%" }}>
                                <FullWidthMobileButton disabled={disableMapBtn} text={disableMapBtn ? intl.formatMessage({ id: "No GPS" }) : intl.formatMessage({ id: "Map" })} color="secondary" onClick={(): void => handleMapClick()} />
                            </div>               
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Graph" })} color="primary" onClick={(): void => handleGraphClick()} />
                        </div>
                        <div style={{ width: (isLandscape || isTablet) ? "100%" : "120%", transform: (isLandscape || isTablet) ? "none" : "translateX(-8%)" }}>
                            <Accordion
                                collapsible={true}
                                multiple={true}
                                style={{ background: '#eeeeee', color: "black", marginTop: "20px" }}
                                defaultSelectedIndex={0}
                            >
                                <Item title={intl.formatMessage({ id: "Device Overview" })}>
                                    <div>
                                        <DeviceSummaryMobile deviceData={deviceData} />
                                    </div>
                                </Item>
                                <Item title={intl.formatMessage({ id: 'Images' })}>
                                    <div style={{ marginTop: 10 }}>
                                        <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "upload/capture" })} color="primary" onClick={(): void => handleUploadPhoto()} />
                                        <MobileImagePanel siteId={null} loggerId={loggerIds} chariotId={null} />
                                    </div>
                                </Item>
                                <Item title={intl.formatMessage({ id: 'Comments' })}>
                                    <div>
                                        <Comments siteId={null} loggerId={loggerIds} lcLoggerId={null} />
                                    </div>
                                </Item>
                                <Item title={intl.formatMessage({ id: 'Events' })}>
                                    <div>
                                        <EventsPanelMobile serials={[serial]} />
                                    </div>
                                </Item>
                            </Accordion>
                        </div>
                    </>
                    }

                </div>
            :
                <Redirect push
                    to={{
                        pathname: redirectPath,
                        state: redirectProps
                    }}
                />
            }
        </>
    )
}

export default DeviceDetailMobile